import { FC } from "react";
import { Stack, Theme } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import {
  FormikSelectField,
  FormikToggleField,
  Modal,
  ModalProps,
  types
} from "@vilocnv/allsetra-core";

export type ObjectsMapFilterFormValues = types.IMapFilter & {
  showInactiveObjects: boolean;
};

export type ObjectsMapFilterFormProps = Pick<ModalProps, "open" | "onClose"> & {
  onSubmit: (
    values: ObjectsMapFilterFormValues,
    formikHelpers: FormikHelpers<ObjectsMapFilterFormValues>
  ) => void;
  theme: Theme;
  dataLoading?: boolean;
  groups: Array<any>;
  types: Array<any>;
  keys: Array<types.IKey>;
  submitting?: boolean;
  initialValues?: ObjectsMapFilterFormValues;
  translator?: any;
};

const DEFAULT_VALUES: ObjectsMapFilterFormValues = {
  groups: [],
  objectTypes: [],
  keyId: [],
  showInactiveObjects: false
};

const ObjectsMapFilterForm: FC<ObjectsMapFilterFormProps> = ({
  open,
  onClose,
  onSubmit,
  theme,
  dataLoading = false,
  groups,
  types,
  keys,
  submitting = false,
  initialValues,
  translator
}) => {
  const t = translator;

  return (
    <Formik
      initialValues={initialValues ?? DEFAULT_VALUES}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ handleSubmit, isSubmitting }) => (
        <Modal
          title={t ? t("buttonsText.filter") : "Filters"}
          theme={theme}
          open={open}
          onClose={onClose}
          secondaryBtnProps={{
            text: t ? t("buttonsText.cancel") : "Cancel",
            onClick: onClose
          }}
          primaryBtnProps={{
            type: "submit",
            text: t ? t("buttonsText.apply") : "Apply",
            loading: isSubmitting || submitting,
            // @ts-ignore
            onClick: handleSubmit
          }}
        >
          <Stack spacing={2}>
            <FormikSelectField
              label={
                t
                  ? t("groups.label", { ns: "formFieldsTranslation" })
                  : "Groups"
              }
              placeholder={
                t
                  ? t("groups.placeholder", { ns: "formFieldsTranslation" })
                  : "Groups"
              }
              name="groups"
              options={groups ?? []}
              optionLabelKey="name"
              optionValueKey="uniqueId"
              loading={dataLoading}
              multiple
              searchable
            />
            <FormikSelectField
              label={
                t
                  ? t("objectType.label", { ns: "formFieldsTranslation" })
                  : "Object Types"
              }
              placeholder={
                t
                  ? t("objectType.placeholder", {
                      ns: "formFieldsTranslation"
                    })
                  : "Object Types"
              }
              name="objectTypes"
              options={types ?? []}
              optionLabelKey="name"
              optionValueKey="uniqueId"
              loading={dataLoading}
              multiple
              searchable
            />
            <FormikSelectField
              label={
                t ? t("keyId.label", { ns: "formFieldsTranslation" }) : "Key"
              }
              placeholder={
                t
                  ? t("keyId.placeholder", { ns: "formFieldsTranslation" })
                  : "Key"
              }
              name="keyId"
              options={keys ?? []}
              optionLabelKey="label"
              optionValueKey="uniqueId"
              loading={dataLoading}
              searchable
              multiple
            />
            <FormikToggleField
              name="showInactiveObjects"
              label={
                t ? t("common.showInactiveObjects") : "Show inactive objects"
              }
            />
          </Stack>
        </Modal>
      )}
    </Formik>
  );
};

export default ObjectsMapFilterForm;
